import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { useSyncQueue } from '../hooks/useSyncQueue';
import { useT } from '../i18n';
import { LanguageSelector } from '../i18n/LanguageSelector';
import { StatusPill } from './ui/StatusPill';

/**
 * Barra fixa de status: conectividade + fila de sincronização (RF-VIA-04, RNF-05).
 * O viajante precisa saber, num relance, se está offline e quantos gastos ainda
 * não chegaram ao servidor.
 */
export function SyncStatusBar() {
  const { t } = useT();
  const online = useOnlineStatus();
  const { pendingCount, failedCount, syncing, triggerSync } = useSyncQueue();

  return (
    <div className="safe-top flex items-center justify-between gap-2 border-b border-line bg-surface px-4 py-2.5">
      <StatusPill tone={online ? 'success' : 'danger'} dot pulse={online}>
        {online ? t('common.online') : t('common.offline')}
      </StatusPill>

      <div className="flex items-center gap-2">
        <LanguageSelector />
        {failedCount > 0 ? (
          <StatusPill tone="danger">{t('sync.failed', { n: failedCount })}</StatusPill>
        ) : null}
        {pendingCount > 0 ? (
          <button
            type="button"
            onClick={triggerSync}
            disabled={syncing || !online}
            className="disabled:opacity-60"
          >
            <StatusPill tone="accent" dot pulse={syncing}>
              {syncing
                ? t('sync.syncing')
                : t(pendingCount > 1 ? 'sync.pendingPlural' : 'sync.pending', { n: pendingCount })}
            </StatusPill>
          </button>
        ) : (
          <StatusPill tone="neutral">{t('sync.allSynced')}</StatusPill>
        )}
      </div>
    </div>
  );
}
